<template>
  <div class="notice_mng">
    <h2 class="title_com">通知公告</h2>
    <section class="pd2430">
      <!-- 搜索 -->
      <MySearch
        :triggerPhName="4"
        :show2="0"
        :show3="0"
        :showSelect1="0"
        :showIpt2="1"
        :showLabel1="1"
        :classVal="1"
        @changeVal="changeVal"
        @resetPage="resetPage"
        @requestCommonFn="requestCommonFn"
      ></MySearch>
      <div class="two_btn">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="sendNoticeFn"
          >发布通知公告</el-button
        >
        <el-button
          icon="el-icon-delete"
          @click="batchDelete"
          type="danger"
          size="small"
          :disabled="multiple"
          >批量删除</el-button
        >
      </div>
      <!-- 表格 -->
      <NoticeTB
        :list="noticeListArr"
        @requestCommonFn="requestCommonFn"
        @changeMultiple="changeMultiple"
        ref="childNoticeTB"
      ></NoticeTB>
      <!-- 分页 -->
      <Pagination
        :currentPage="currentPage"
        :pageSize="pageSize"
        :total="total"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage"
        @changeSize="changeSize"
        v-if="total !== 0"
      ></Pagination>
    </section>
  </div>
</template>

<script>
import { NoticeListApi } from "@/api/tearcher";
export default {
  data() {
    return {
      title: "", // 公告标题
      sendMan: "", // 发布人
      class_id: "", //
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
      noticeListArr: [], // 通知公告列表
      multiple: true,
    };
  },
  methods: {
    // 重置页数
    resetPage() {
      this.currentPage = 1;
    },
    // changeMultiple
    changeMultiple(val) {
      this.multiple = val;
    },

    // 批量删除
    batchDelete() {
      this.$refs.childNoticeTB.handleDelete({});
    },
    // 发布公告
    sendNoticeFn() {
      this.$router.push({ path: "/SendNotice" });
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    // 修改查询的值
    changeVal(val) {
      this.title = val.workName;
      this.sendMan = val.modelVal;
    },
    // 通知公告列表
    requestCommonFn() {
      NoticeListApi({
        limit: this.pageSize,
        page: this.currentPage,
        class_id: this.class_id, //
        title: this.title, // this.class_id
        username: this.sendMan, // this.class_id
      }).then((res) => {
        this.noticeListArr = res.data.list;
        this.total = res.data.total;
      });
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      this.requestCommonFn();
      //   console.log("切换班级");
    },
  },
  created() {
    this.createFn();
  },
};
</script>

<style lang="less" scoped>
/deep/.my_search {
  .el-form-item {
    margin-left: 0;
    margin-right: 50px;
    &:nth-of-type(2) {
      margin-right: 0;
    }
  }
}
</style>
